import React from 'react';
import Image from 'app/Components/Shared/Image/image';
const BitPendingLabel = (props) => {
  return (
    <div className='bit-pending-label'>
      <span>
        <Image src={require('../images/time.svg')} alt='bit-pending-label' />
      </span>
      <span className='m-title bold'>תהליך התשלום דרך bit טרם הושלם </span>
    </div>
  );
};

export default BitPendingLabel;
